import React, { useMemo } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { FormattedMessage, useIntl } from "react-intl";
import { useCallback } from "react";
import CountDown from '../../../../../../../../client/components/count-down';
import { BlackMask } from '../../../../../../../../client/components/mask/index'
import { useState } from "react";
import BottomToTop from '../../../../../../../../client/components/transitions/bottom-to-top';
import { Iconfont } from '../../../../../../../../client/components/icon/iconfont';
import { fetchMssageByTypeCode } from "../../../../../../../../api";
import { useEffect } from "react";
import { fetchUnifiedProcessing } from "../../../../../utils";
import { BigButton } from '../../../../../../../../client/components/button/index';
import { useDispatch } from "react-redux";
import { action_fetch_order_detail } from "../../../../../../../../store/actions/pages/customer";
import { fetchCancelOrder } from "../../../../../../../../api";
import Alert from '../../../../../../../../client/components/alert/index';
import ConfigConfirm from "../../../../../../../../client/components//alert/config-confirm";
import Toast from "../../../../../../../components/toast";
import { addToCarts } from "../../../../../../../../api";
import { action_fetch_cart_count } from "../../../../../../../../store/actions/global";


const CancelOrderReason = props =>{
    const { orderId, onClose, addProducts } = props;
    const [reasons, setReasons] = useState(null);
    const [reasonValue, setReasonValue] = useState('');
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    useEffect(async () =>{
        let response = await fetchMssageByTypeCode('cancel-order-reasons');
        setReasons(fetchUnifiedProcessing(response));
    }, []);

    const submitHandle = useCallback(async (value, orderId) =>{
        setLoading(true);
        let response = await fetchCancelOrder({orderId, cancelReason:value});
        if(response?.code === 200){
            dispatch(action_fetch_order_detail(orderId));
            onClose?.();
            ConfigConfirm({
                boxStyle:{
                },
                close:{
                    style:{}
                },
                title:{
                    text:"",
                    style:{}
                },
                message:{
                    text: Intl.formatMessage({ id: "reason_submit_success_message", defaultMessage: "Submitted successfully! Would you like to add the product to your shopping bag again?" }),
                    style:{},
                    html:true
                },
                btn1:{
                    text:Intl.formatMessage({ id: "add_to_bag", defaultMessage: "Add To Bag" }),
                    clickHandle:() =>{
                        addProducts();
                    }
                },
                btn2:{
                    text: Intl.formatMessage({ id: "continue_shopping", defaultMessage: "Continue Shopping" }),
                    clickHandle:() =>{
                        window.location.href = "/";
                    }
                }
            });
        }else{
            onClose?.();
            response?.result && Alert(response.result);
        }
        setLoading(false);
    }, []);

    return <div className={cls.CancelOrderReason}>
        <Iconfont className={cls.CloseIcon} onClick={onClose}>&#xe69a;</Iconfont>

        <div className={cls.Title}>
            <FormattedMessage id="select_reason" defaultMessage="Select a reason" />
        </div>

        {
            reasons?.length > 0 ? <div className={cls.ReasonList}>
                {
                    reasons.map((reason, index) =>(
                        <div className={cls.ReasonItem} key={index} onClick={() =>setReasonValue(reason?.value)}>
                            <span>{reason?.label}</span>

                            <input type="radio" className={`${reason.value===reasonValue?cls.Active:''}`} />
                        </div>
                    ))
                }
            </div> : <div className={cls.ReasonListLoading}><FormattedMessage id="loading" defaultMessage="Loading" />...</div>
        }
        

        <div className={cls.SubmitButton}>
            <BigButton onClick={() =>submitHandle(reasonValue, orderId)} loading={loading} disabled={!reasonValue}><FormattedMessage id="submit" defaultMessage="Submit" /></BigButton>
        </div>
    </div>
}

export const CancelOrderReasonModal = props =>{
    const { show, onClose } = props;

    return <React.Fragment>
        <BottomToTop in={show} className={cls.CancelOrderReasonModal}>
            <div>
                <CancelOrderReason {...props} />
            </div>
        </BottomToTop>

        {
            show && <BlackMask onClick={onClose} />
        }
    </React.Fragment>
}

const CancelOrderModal = props =>{
    const { offSet, onClose, onConfirm } = props;

    return <React.Fragment>
        <div className={cls.CancelOrderModal}>
            <p className={cls.Title}>
                <FormattedMessage id="you_sure_cancel" defaultMessage="Are you sure you want to cancel payment? If your order is not paid in" /> 
                <CountDown offset={offSet} showHour style={{margin: '0 3px', color: '#e96060'}} />
                , <FormattedMessage id="it_will_cancel" defaultMessage="it will be canceled" />
            </p>

            <div className={cls.BtnContainer}>
                <button onClick={onConfirm}><FormattedMessage id="confirm_cancel" defaultMessage="Confirm Cancel" /></button>

                <button onClick={onClose}><FormattedMessage id="continue_to_pay" defaultMessage="Continue To Pay" /></button>
            </div>
        </div>

        <BlackMask onClick={onClose} />
    </React.Fragment>
}


export default props =>{
    useStyles(cls);
    const { orderDetail } = props;
    const Intl = useIntl();
    const [calcelOrder, setCancelOrder] = useState(false);
    const [showReason, steShowReason] = useState(false);
    const dispatch = useDispatch();

    const orderOffset = useMemo(() =>{
        if(orderDetail?.expiredPaymentTime){
            return orderDetail.expiredPaymentTime - orderDetail?.serverTime;
        }
    }, [orderDetail]);

    const cancelOrderHandle = useCallback((evt) =>{
        evt.preventDefault();
        setCancelOrder(true);
    }, []);

    const addProducts = useCallback(async (products) =>{
        let params = products?.map(product =>({"variantId":product.variantId,"quantity":'1'}));
        let response = await addToCarts(params);
        if(response?.code === 200){
            Toast(Intl.formatMessage({ id: "add_success", defaultMessage: "Add Success" }));
            dispatch(action_fetch_cart_count());
        }else{
            Alert(response?.result || Intl.formatMessage({ id: "add_failed", defaultMessage: "Add Failed" }));
        }
    }, []);

    return <div className={cls.OrderServiceReturn}>
        <div className={cls.Container}>
            {
                orderDetail?.isCanCanceled && <a onClick={cancelOrderHandle} className={cls.LinkItem}><FormattedMessage id="cancel_order" defaultMessage="Cancel Order" /></a>
            }

            {
                orderDetail?.hasReturnLabel && <a href={`/v9/order/report-return-label?orderId=${orderDetail?.id}`} className={cls.LinkItem}><FormattedMessage id="return_label" defaultMessage="Return Label" /></a>
            }
        </div>

        {
            orderDetail?.unPayMessage && <div className={cls.TipMsg}>
                <p>{orderDetail.unPayMessage}</p>
            </div>
        }
        
        {
            calcelOrder && <CancelOrderModal offSet={orderOffset} onClose={() =>setCancelOrder(false)} onConfirm={() =>{setCancelOrder(false);steShowReason(true);}} />
        }

        <CancelOrderReasonModal show={showReason} onClose={() =>steShowReason(false)} orderId={orderDetail?.id} addProducts={() =>addProducts(orderDetail?.orderItems)} />
    </div>
}